import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getInvestorApiUrl } from "../../utils/config";
import { ApiRequestParams, handleFetchApi } from "../../utils/api";

const initialState = {
  businessType:[],
  businesscategory :[],
  subCategory:[],
  setSubCategory:'',
  business:[],
  loading:false,
  paymentBankDetails:"",
  kycDetails:"",
  error:null
};

// Async thunk to fetch states
export const fetchBusinesscategory = createAsyncThunk(
  "business/fetchBusinesscategory",
  async (_, thunkApi) => {
    try {
      const params: ApiRequestParams = {
              baseUrl: getInvestorApiUrl(),
              endpoint: `investor/business-category-type`,
            }
            const response = await handleFetchApi(params)
      // const response = await axios.get(`${baseUrl}/investor/business-category-type`);
      const data= {category : response.data.data.categories, types : response.data.data.types}
      return data
    } catch (error:any) {
      return thunkApi.rejectWithValue(
        error.response?.data || "Failed to fetch states"
      );
    }
  }
);

export const paymentMasterDetails = createAsyncThunk(
  "business/paymentMasterDetails",
  async (type, thunkApi) => {
    try {
      const params: ApiRequestParams = {
        baseUrl: getInvestorApiUrl(),
        endpoint: `investor/payment-master-details/${type}`,
      }
      const response = await handleFetchApi(params)
      // const response = await axios.get(`${baseUrl}/investor/payment-master-details/${type}`);
      return response.data
    } catch (error:any) {
      return thunkApi.rejectWithValue(
        error.response?.data || "Failed to fetch states"
      );
    }
  }
);

export const kybInvestorId = createAsyncThunk(
  "business/kybInvestorId",
  async (kybPayload:any, thunkApi) => {
    const { investorId, ...payload } = kybPayload;

    try {
      const params: ApiRequestParams = {
        baseUrl: getInvestorApiUrl(),
        endpoint: `kyb/${investorId}`,
        payload,
        method:"POST",
      }
      const response = await handleFetchApi(params)
      // const response = await axios.post(`${baseUrl}/kyb/${investorId}`, payload);
      const data= response.data
      return data
    } catch (error:any) {
      return thunkApi.rejectWithValue(
        error.response?.data || "Failed to fetch states"
      );
    }
  }
);


const businessSlice = createSlice({
  name: "business",
  initialState,
  reducers: {
    setSubCategory : (state, action) => {
      state.subCategory = action.payload;
  },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchBusinesscategory.pending, (state) => {
        state.loading = true;
        state.kycDetails = "";
      })
      .addCase(fetchBusinesscategory.fulfilled, (state, action) => {
        state.loading = false;
        state.businesscategory = action.payload.category
        state.businessType = action.payload.types
      })
      .addCase(fetchBusinesscategory.rejected, (state, action:any) => {
        state.loading = false;
        state.error = action.payload || "Failed to post ledger configuration";
      })
      .addCase(paymentMasterDetails.pending, (state) => {
        state.loading = true;
        state.paymentBankDetails = "";
      })
      .addCase(paymentMasterDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.paymentBankDetails = action.payload
      })
      .addCase(paymentMasterDetails.rejected, (state, action:any) => {
        state.loading = false;
        state.error = action.payload || "Failed to post ledger configuration";
      })
      .addCase(kybInvestorId.pending, (state) => {
        state.loading = true;
        state.kycDetails = "";
      })
      .addCase(kybInvestorId.fulfilled, (state, action) => {
        state.loading = false;
        state.businesscategory = action.payload.category
        state.businessType = action.payload.types
      })
      .addCase(kybInvestorId.rejected, (state, action:any) => {
        state.loading = false;
        state.error = action.payload || "Failed to post ledger configuration";
      })
  },
});

export const { setSubCategory } = businessSlice.actions;

export default businessSlice.reducer;
